var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row round-lg shadow-lg mb-1 mx-auto m-0",class:{
    limited: _vm.forceBreak,
    'white-mode': _vm.whiteMode,
    'survey-card': !_vm.isJourneyTypeNone,
    'survey-card-none': _vm.isJourneyTypeNone,
  }},[(!_vm.isJourneyTypeNone)?_c('div',{staticClass:"primary d-flex flex-column justify-content-around align-items-stretch col-12 col-lg-6 p-2 pt-4 p-sm-4 pb-5 pb-sm-0 bg-accent",class:{
      'bg-white': _vm.whiteMode,
      'col-lg-12': _vm.forceBreak || _vm.hasManyClasses,
      'nps-color': _vm.npsColor,
      neutral: _vm.rating == _vm.NEUTRAL,
      detractor: _vm.rating == _vm.NEGATIVE,
      promotor: _vm.rating == _vm.POSITIVE,
    },attrs:{"id":"ratingSide"}},[_vm._t("primary")],2):_vm._e(),_c('div',{staticClass:"secondary d-flex flex-column justify-content-around align-items-stretch col-12 px-2 pb-5 pt-sm-1 pb-sm-3 px-sm-4 py-sm-0 mt-sm-0 mt-n4",class:{
      'col-lg-12': _vm.forceBreak || _vm.hasManyClasses,
      hide__tt: _vm.hideSecondaryTemplate,
      'col-lg-6': !_vm.isJourneyTypeNone,
    },attrs:{"id":"classesSide"}},[_vm._t("secondary")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }